module.exports = __webpack_public_path__ + "static/media/fork-sausage.ba6ee888.svg";